// extracted by mini-css-extract-plugin
export default {"sport-btn":"sport-modal_sport-btn__UoYkv","sports-1":"sport-modal_sports-1__DXq3-","sports-2":"sport-modal_sports-2__pJi1C"};